import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { tap } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatError, MatFormField, MatInput } from '@angular/material/input';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss'],
  imports: [
    FlexLayoutModule,
    ReactiveFormsModule,
    MatProgressSpinner,
    MatFormField,
    MatInput,
    NgIf,
    MatError,
    MatButton,
  ],
})
export class SigninComponent implements OnInit {
  private authToken: string;

  urlLogoIDS = 'assets/image/Logo-long-white.png';
  signInForm: FormGroup;
  loadingSignIn = false;
  company_name = 'RestoreUnited';
  isVerified: any;
  verifing = false;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.signInForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });
  }

  private authLogin() {
    const email = this.signInForm.get('email').value;
    const password = this.signInForm.get('password').value;

    this.authService
      .login(email, password)
      .pipe(
        tap((user: any) => {
          this.authToken = [user['token_type'], user['access_token']].join(' ');
          localStorage.setItem('token', this.authToken);
          this.router.navigate(['/companies/list-companies']);
        })
      )
      .subscribe(
        () => {},
        err => this.handleError(err)
      );
  }

  private handleError(err) {
    this.loadingSignIn = false;
    if (
      typeof err.error.error !== 'undefined' &&
      err.error.error === 'invalid_verify'
    ) {
      this.signInForm
        .get('email')
        .setErrors({ emailVerify: true, emailInvalid: false });
      this.signInForm.get('password').setErrors({ passwordInvalid: false });
    } else {
      this.signInForm.get('email').setErrors({ emailInvalid: true });
      this.signInForm.get('password').setErrors({ passwordInvalid: true });
    }
  }
  onSignIn() {
    this.signInForm.controls.email.markAsDirty();
    this.signInForm.controls.password.markAsDirty();
    if (this.signInForm.valid) {
      this.loadingSignIn = true;
      this.authLogin();
    }
  }
}
